import React from 'react'
import { cn } from '@/lib/utils'

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl'
  className?: string
  variant?: 'default' | 'icon'
}

export const Spinner: React.FC<SpinnerProps> = ({ 
  size = 'md', 
  className,
  variant = 'default'
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
    xl: 'h-12 w-12',
  }

  if (variant === 'icon') {
    return (
      <div
        className={cn(
          'animate-spin',
          sizeClasses[size],
          className
        )}
      >
        <img 
          src="/icon.png" 
          alt="Loading..." 
          className="h-full w-full object-contain"
        />
      </div>
    )
  }

  return (
    <div
      className={cn(
        'animate-spin rounded-full border-2 border-muted border-t-primary',
        sizeClasses[size],
        className
      )}
    />
  )
}

